.do{padding:0.5rem;}